import React from 'react';

import { CompaniesModal, SimpleCenteredModal } from '../../../components';

const SelectCurrentCompanyIndex = () => (
  <SimpleCenteredModal
    size="md"
    backdrop="static"
    title="Selecciona una empresa"
    closeButton={false}
    body={<CompaniesModal />}
    show
  />
);

export default SelectCurrentCompanyIndex;
